export class SqlVmNetworkInfo {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "subnetId",
            "baseName": "subnetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "virtualNetworkName",
            "baseName": "virtualNetworkName",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetName",
            "baseName": "subnetName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SqlVmNetworkInfo.attributeTypeMap;
    }
    constructor() {
    }
}
